<app-home-hero-carousel></app-home-hero-carousel>

<!-- Sections will be added here -->
<app-home-why-choose-us></app-home-why-choose-us>
<!-- <app-home-best-selling></app-home-best-selling> -->
<app-home-locations></app-home-locations>
<app-home-experiences
  id="experiences"
  (readMoreClicked)="scrollToExperiences()"
></app-home-experiences>
<app-home-materials></app-home-materials>
<app-home-testimonials></app-home-testimonials>
